/**
 * Model class for Diseases
 */

import {email, minLength, maxLength, numeric, required, sameAs} from 'vuelidate/lib/validators'
import Api from '@/providers/Api'
import { store } from '@/store'
import i18n from '@/providers/i18n'
import _ from 'lodash'
import Symptom from '@/models/Symptom'

// build select options based on master list of disease types
function buildDiseaseTypeOptions () {
    const diseaseTypes = store.state.diseaseTypes
    let options = _.map(diseaseTypes, (diseaseType) => {
        return {
            value: `disease_types/${diseaseType.id}`,
            text: i18n.getDiseaseTypeName(diseaseType.id),
        }
    })
    options = _.sortBy(options, ['text'])
    return options
}

export default {
    // load master list of diseases into the store
    async loadDiseases () {
        store.state.diseases = await Api.getAllItems(null, 'diseases')
    },

    // load master list of disease types into the store
    async loadDiseaseTypes () {
        store.state.diseaseTypes = await Api.getAllItems(null, 'disease_types')
    },

    buildDiseaseTypeOptions: buildDiseaseTypeOptions,

    // helper method to load diseases
    buildDiseaseOptions () {
        const diseases = store.state.diseases
        let options = _.map(diseases, (disease) => {
            return {
                value: `diseases/${disease.id}`, text: i18n.getDiseaseName(disease.id)
            }
        })
        return _.sortBy(options, ['text'])
    },

    fields: {
        name: {
            translationKey: 'DISEASE_NAME_FIELD',
            type: 'text',
            validations: { required }
        },
        name_es: {
            translationKey: 'DISEASE_NAME_ES_FIELD',
            type: 'text',
            // validations: { required }
        },
        diseaseTypeId: {
            translationKey: 'DISEASE_TYPE_FIELD',
            type: 'select',
            options: [],
            loadOptions: async function(model) {
                this.options = buildDiseaseTypeOptions()
            },
        },
        symptoms: {
            translationKey: 'DISEASE_SYMPTOMS_FIELD',
            type: 'checks',
            options: [],
            class: 'disease-symptoms',
            loadOptions: async function(model) {
                this.options = Symptom.buildSymptomOptions()
            },
            collapsible: true,
        },
        factSheetUrl: {
            translationKey: 'DISEASE_FACT_SHEET_URL_FIELD',
            type: 'url',
        },
        factSheetUrl_es: {
            translationKey: 'DISEASE_FACT_SHEET_URL_ES_FIELD',
            type: 'url',
        },
        textSections: {
            translationKey: 'DISEASE_TEXT_SECTIONS_FIELD',
            type: 'textsections',
        },
        // TODO: symptoms?
    }
}
